import { createContext } from 'react';
import { defaultPreferences, LocalPreferences } from '@/core/preferences/export';

export interface AppContext {
  showMenu: boolean;
  localPreferences: LocalPreferences;
}

export const Context = createContext<AppContext>({
  showMenu: true,
  localPreferences: defaultPreferences(),
});
